<template>
    <v-container style="padding-top:80px" width="100%" id="Reasignacion">
        <v-card>
            <v-card-title class="justify-center primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-swap-horizontal</v-icon>
                <v-toolbar-title id="titulocard">Reasignación Líderes</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pa-5 pt-4">
                <v-row justify="center" v-if="loaded">
                    <v-col cols="12" md="6">
                        <v-skeleton-loader
                            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                    </v-col>
                </v-row>
                <v-row justify="center" v-else>
                    <v-col cols="12" md="7">
                        <v-row align="center" style="display: grid; place-items: center;">
                            <v-col cols="12" md="6">
                                <v-card elevation="6" style="min-height: 250px;" outlined>
                                    <v-card-title>
                                        <v-row justify="center" style="display: grid;">
                                            <v-col cols="12" md="7">
                                                <v-icon color="primary" size="60">mdi-account-circle</v-icon>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-divider class="my-3 custom-divider"></v-divider>
                                    <v-card-text class="mb-0">
                                        <v-row v-if="datoslider.Lduslogin != ''" justify="center"
                                            align-content="center">
                                            <v-col cols="6"
                                                style=" display: grid; place-items: center; margin-top: 5%;">
                                                <span class="etiqueta-style">Reporte: </span>
                                                <p>{{ datoslider.nrreporte }} - {{ datoslider.svindice }}</p>
                                            </v-col>
                                            <v-col cols="6"
                                                style=" display: grid; place-items: center; margin-top: 5%;">
                                                <span class="etiqueta-style">Líder actual: </span>
                                                <p>{{ datoslider.nombre }}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="datoslider.Lduslogin == ''" justify="center"
                                            align-content="center">
                                            <v-col cols="12"
                                                style=" display: grid; place-items: center; margin-top: 5%;">
                                                <span class="etiqueta-style">Reporte: </span>
                                                <p>{{ datoslider.nrreporte }} - {{ datoslider.svindice }}</p>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <span class="etiqueta-style">Líder: </span>
                                <multiselect v-model="lideres.uslogin"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" select-label="Seleccione un lider" track-by="uslogin"
                                    label="usnom" placeholder="Seleccione una opción" :options="lideres.opcionesLideres"
                                    :allow-empty="false">
                                </multiselect>
                                <span style="color: #FF5C93; display: none" id="opcError">Campo requerido</span>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disBtn"
                        @click="Asignar()">Asignar</v-btn>
                    <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    data: function () {
        return {
            loaded: true,
            datoslider: null,
            disBtn: false,
            lideres: {
                opcionesLideres: [],
                uslogin: '',
                usnom: ''
            },
            permisoReasignarLider: false,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '148').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 148)//Permiso para ver concluidos
                        this.permisoReasignarLider = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        //document.removeEventListener('visibilitychange', this.visibilitychange);

        this.datoslider = await MetodosGenerales.obtenerSessionReporte('lider');
        if (this.datoslider.Lduslogin != '') {
            let response = await Lideres.DatosLider(this.datoslider.Lduslogin);
            this.datoslider.nombre = response.usnom
        }
        await Lideres.ObtenerLideresActivos(this);
        this.loaded = false;
    },
    watch: {
        "lideres.uslogin"(val) {
            if (val != null) {
                document.getElementById("opcError").style.display = "none";
            }
        },
    },
    methods: {
        Cancelar() {
            this.$router.push({ name: `LideresMain` });
        },
        async Asignar() {
            let valdacion = this.lideres.uslogin == '' ? false : true;
            if (valdacion == false) { document.getElementById("opcError").style.display = "block"; }
            if (valdacion) {
                this.disabled = true;
                this.$swal({
                    title: 'Reasignando reporte ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        var formData = new FormData();
                        formData.append("nrreporte", this.datoslider.nrreporte);
                        formData.append("svindice", this.datoslider.svindice);
                        formData.append("lduslogin", this.lideres.uslogin.uslogin);
                        let response = await Lideres.GuardarReasignacion(formData);
                        if (response == true) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: "Se reasignó el reporte con éxito.",
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.$router.push({ name: `LideresMain` });
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: "Ocurrió un error al reasignar el reporte, inténtelo de nuevo",
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    }
                })
            }
        }

    }
}

</script>

<style>
.etiqueta-style {
    font-weight: bold;
}

#Reasignacion .theme--light.v-card>.v-card__text,
.theme--light.v-card>.v-card__subtitle {
    color: rgba(0, 0, 0, 1);
}

#Reasignacion .theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
    color: rgba(255, 255, 255, 1);
}

.custom-divider {
    border-top: 10px solid;
    border-style: dotted;
}
</style>